module.exports = __webpack_public_path__ + "static/media/Bel.28a8d364.mp3";